import { useSetState } from 'ahooks'
import dayjs from 'dayjs'

interface T {
  afterOpen?: (data?: any) => void
  afterOk?: (...args: any[]) => Promise<any>
  afterCancel?: () => void
}
export default ({ afterOpen, afterOk, afterCancel }: T) => {
  const [{ open, modalData }, setState] = useSetState<{
    open: boolean
    modalData?: any
  }>({
    open: false,
    modalData: {}
  })
  const onOpen = (data?: any) => {
    const _state: any = { open: true }
    data && (_state.modalData = { ...modalData, ...data })
    setState(_state)
    afterOpen?.()
  }
  const onCancel = () => {
    setState({ open: false })
    afterCancel?.()
  }
  const onOk = (...args: any[]) => {
    afterOk?.(...args).then(() => {
      onCancel()
    }) || onCancel()
  }
  const setModalData = (_: any) => {
    console.log('setModalData---@@@>>>>', _)
    setState({ modalData: { ...modalData, ..._ } })
  }
  return {
    open,
    modalData,
    setModalData,
    onOpen,
    onOk,
    onCancel
  }
}
